import { render } from "./WhistlesView.vue?vue&type=template&id=74839f30&scoped=true&ts=true"
import script from "./WhistlesView.vue?vue&type=script&lang=ts"
export * from "./WhistlesView.vue?vue&type=script&lang=ts"

import "./WhistlesView.vue?vue&type=style&index=0&id=74839f30&scoped=true&lang=css"
import "@/assets/css/style.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74839f30"]])

export default __exports__